import { ChatRoomMessageChannel } from '@commenda/prisma';
import { fetcher } from '@commenda/utils';

export type ChatRoomChannel = ChatRoomMessageChannel;

/**
 * Mark chat room as read. Optionally advance cursor to a specific message (e.g. when user scrolls to it).
 * When channel is provided without lastReadMessageId, only that channel is marked as read (so the other tab's unread count is preserved).
 * Use `markedAsUnread: true` to set manual unread without moving the read cursor (all allowed channels on the server).
 */
export async function updateChatRoomReadStatus(
  chatRoomId: string,
  token?: string,
  options?: {
    lastReadMessageId?: string;
    channel?: ChatRoomChannel;
    markedAsUnread?: boolean;
  }
) {
  const hasOptions =
    options?.lastReadMessageId != null ||
    options?.channel != null ||
    options?.markedAsUnread === true;
  const body = hasOptions
    ? {
        ...(options?.lastReadMessageId != null && {
          lastReadMessageId: options.lastReadMessageId,
        }),
        ...(options?.channel != null && { channel: options.channel }),
        ...(options?.markedAsUnread === true && { markedAsUnread: true }),
      }
    : undefined;
  const res = await fetcher(
    `chatRoom/mark-as-read/${chatRoomId}`,
    {
      method: 'PATCH',
      ...(body != null && { body }),
    },
    token
  );

  return res;
}
